var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatusArrowTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 24,
    width: 24,
    height: 24,
    rx: 4,
    transform: "rotate(-180 24 24)",
    fill: "#F7D4D7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0117 11.0483C16.7089 11.3309 16.2343 11.3146 15.9517 11.0117C14.955 9.94716 13.9101 8.88214 12.75 7.99282V17.2499C12.75 17.6641 12.4142 18 12 18C11.5858 18 11.25 17.6636 11.25 17.2494V7.99282C10.0894 8.88255 9.04712 9.94491 8.04829 11.0117C7.76566 11.3146 7.29107 11.3309 6.98826 11.0483C6.68545 10.7657 6.66919 10.291 6.95182 9.98814C8.03442 8.82876 9.15294 7.68998 10.425 6.73594C10.871 6.4014 11.4166 6 12 6C12.5834 6 13.129 6.4014 13.575 6.73594C14.8394 7.68424 15.9692 8.83912 17.0483 9.98826C17.3309 10.2911 17.3145 10.7657 17.0117 11.0483Z",
    fill: "#660008"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusArrowTop);
export default __webpack_public_path__ + "static/media/statusArrowTop.b465a3dcf5bd504c5eabf3c5f8b57177.svg";
export { ForwardRef as ReactComponent };